// extracted by mini-css-extract-plugin
export default {"break":"MatchQuestion_break__jnwHy","question":"MatchQuestion_question__yI6s5","column":"MatchQuestion_column__2XcTx"};